import React from 'react';

const SupportAndFeedback = () => {
  return <h2>Support & Feedback</h2>;
};

export default SupportAndFeedback;
